import request from '@/CommonDP/utils/request';
// 图框定制字段管理
export default {
  // 列表
  frameCustomizationList(params) {
    return request.post(`/frameCustomization/list`,
      params
    );
  },
  addFrameCustomization(params) {
    return request.post(
      `/frameCustomization/addFrameCustomization`,
      params
    );
  },
  queryFrameCustomizationDetail(id) {
    return request.get(
      `/frameCustomization/queryFrameCustomizationDetail?id=${id}`
    );
  },
  // 修改
  updateFrameCustomization(params) {
    return request.post(
      `/frameCustomization/updateFrameCustomization`,
      params
    );
  },
  // 删除
  deleteFrameCustomization(params) {
    return request.post(
      '/frameCustomization/deleteFrameCustomization',
      params
    );
  },
  // 上移，下移数据
  moveFrameCustomization(params) {
    return request.post(
      '/frameCustomization/move',
      params
    );
  }
};
